import React from 'react';
import styles from '../amandacgazoni/amandacgazoni.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MakeIcon from '../../icons/makeIcon.tsx';

const Amandacgazoni: React.FC = () => {
    return (
        <div className={styles.amandacgazoni}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2 pb-0">Dra Amanda Gazoni</h1>
                    <p className="mb-3">FARMACÊUTICA ESTETA</p>
                    <div className={styles.links}>
                        <>
                            <LinkPersonalizado7
                                href="/amandacgazoni/localizacoes"
                                title="LOCALIZAÇÕES"
                                icon={<MapsIcon height="40" color="#ffffff" />}
                                colorText="#cbb353"
                                linkInterno={true}
                            />
                            <LinkPersonalizado7
                                href="https://www.instagram.com/amandacgazoni?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                title="INSTAGRAM"
                                icon={<InstagramIcon height="34" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517996569096"
                                title="WHATSAPP"
                                icon={<WhatsappIcon height="40" color="#ffffff" />}
                                colorText="#cbb353"
                            />
                            <LinkPersonalizado7
                                href="/amandacgazoni/procedimentos"
                                title="PROCEDIMENTOS"
                                icon={<MakeIcon height="40" width="40" color="#ffffff" />}
                                colorText="#cbb353"
                                linkInterno={true}
                            />
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Amandacgazoni;
